import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PlanningComponent } from './planning/planning.component';
import { StandardReview } from './planning/standard-review/standard-review';
import { ReviewManagementComponent } from './review-management/review-management.component';
import { ReviewProcessComponent } from './review-process/review-process.component';
import { IssueManagementComponent } from './issue-management/issue-management.component';
import { IssueViewEditComponent } from './issue-management/issue-view-edit/issue-view-edit.component';
import { ActionPlanComponent } from './action-plan/action-plan.component';
import { ActionViewEditComponent } from './action-plan/action-view-edit/action-view-edit.component';
import { MasterComponent } from './master/master.component';
import { RequestComponent } from './request/request.component';
import { RequestViewEdit } from './request/request-view-edit/request-view-edit';
import { ReportComponent } from './report/report.component';
import { HelpComponent } from './help/help.component';
import { TimelineCalculatorComponent } from './help/timeline-calculator/timeline-calculator.component';
import { ImportStandardReview } from './planning/import-standard-review/import-standard-review';
import { AdminComponent } from './admin/admin.component';
import { ViewAdminRolePermissionsComponent } from './admin/view-admin-role-permissions/view-admin-role-permissions.component';
import { NoAccessComponent } from './admin/no-access/no-access.component';
import { AuditLogDetailComponent } from './admin/audit-log/audit-log-detail/audit-log-detail.component';

export const routes: Routes = [

  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent, canActivate: [MsalGuard] },
  { path: 'planning', component: PlanningComponent, canActivate: [MsalGuard] },
  { path: 'planning/standard-review', component: StandardReview, canActivate: [MsalGuard] },
  { path: 'planning/go-live-review', component: StandardReview, canActivate: [MsalGuard] },
  { path: 'planning/on-demand-review', component: StandardReview, canActivate: [MsalGuard] },
  { path: 'planning/special-project-review', component: StandardReview, canActivate: [MsalGuard] },
  { path: 'planning/import-standard-review', component: ImportStandardReview, canActivate: [MsalGuard] },
  { path: 'review-management', component: ReviewManagementComponent, canActivate: [MsalGuard] },
  { path: 'review-management/review-process', component: ReviewProcessComponent, canActivate: [MsalGuard] },
  { path: 'issue-management', component: IssueManagementComponent, canActivate: [MsalGuard] },
  { path: 'issue-management/:issueId', component: IssueViewEditComponent, canActivate: [MsalGuard] },
  { path: 'action-plan', component: ActionPlanComponent, canActivate: [MsalGuard] },
  { path: 'action-plan/:actionPlanId', component: ActionViewEditComponent, canActivate: [MsalGuard] },
  { path: 'master', component: MasterComponent, canActivate: [MsalGuard] },
  { path: 'request', component: RequestComponent, canActivate: [MsalGuard] },
  { path: 'request/view-edit', component: RequestViewEdit, canActivate: [MsalGuard] },
  { path: 'report', component: ReportComponent, canActivate: [MsalGuard] },
  { path: 'help', component: HelpComponent, canActivate: [MsalGuard] },
  { path: 'help/frequently-asked-questions', component: HelpComponent, canActivate: [MsalGuard] },
  { path: 'help/macronize-timeline-calculator', component: TimelineCalculatorComponent, canActivate: [MsalGuard] },
  { path: 'admin', component: AdminComponent, canActivate: [MsalGuard] },
  { path: 'admin/no-access', component: NoAccessComponent, canActivate: [MsalGuard] },
  { path: 'admin/view-role-permissions', component: ViewAdminRolePermissionsComponent, canActivate: [MsalGuard] },
  { path: 'admin/audit-log/:applicationLogId', component: AuditLogDetailComponent, canActivate: [MsalGuard] },

];
